import React from 'react';
import { Hand, Menu, Minus, Plus, RotateCcw, Scan, Scaling } from 'lucide-react';

const IconButton = ({ label, testId, onClick, children }) => (
  <button
    type="button"
    aria-label={label}
    title={label}
    onClick={onClick}
    className="flex h-9 w-9 shrink-0 items-center justify-center rounded-sm border border-border bg-card text-foreground shadow-sm transition-colors hover:bg-secondary active:bg-primary/10"
    data-testid={testId}
  >
    {children}
  </button>
);

export const WorkbenchToolbar = ({ surface, scale, onMenu, onZoomIn, onZoomOut, onFit, onActual, onReset }) => (
  <header className="flex h-12 shrink-0 items-center gap-1.5 border-b border-border bg-background/95 px-2 shadow-sm backdrop-blur" data-testid="workbench-toolbar">
    <IconButton label="Open pages" testId="workbench-page-drawer-open" onClick={onMenu}><Menu className="h-4 w-4" /></IconButton>
    <div className="hidden min-w-0 items-center gap-2 px-1 min-[390px]:flex">
      <Hand className="h-3.5 w-3.5 shrink-0 text-primary" />
      <span className="truncate text-[11px] font-semibold uppercase tracking-[0.12em]" data-testid="workbench-surface-label">
        {surface === 'admin' ? 'Admin' : 'The Loom'}
      </span>
    </div>
    <div className="ml-auto flex items-center gap-1.5">
      <IconButton label="Zoom out" testId="workbench-zoom-out" onClick={onZoomOut}><Minus className="h-4 w-4" /></IconButton>
      <output className="w-11 text-center font-mono-stat text-[11px] font-semibold" data-testid="workbench-zoom-level">{Math.round(scale * 100)}%</output>
      <IconButton label="Zoom in" testId="workbench-zoom-in" onClick={onZoomIn}><Plus className="h-4 w-4" /></IconButton>
      <IconButton label="Fit width" testId="workbench-fit-width" onClick={onFit}><Scaling className="h-4 w-4" /></IconButton>
      <IconButton label="Actual size" testId="workbench-actual-size" onClick={onActual}><Scan className="h-4 w-4" /></IconButton>
      <IconButton label="Reset view" testId="workbench-reset-view" onClick={onReset}><RotateCcw className="h-4 w-4" /></IconButton>
    </div>
  </header>
);